const banks = {
  Sberbank: {
    title: 'WithdrawToCard | Sberbank',
    value: '100000000111',
  },
  Tinkoff: {
    title: 'WithdrawToCard | Tinkoff',
    value: '100000000004',
  },
  Vtb: {
    title: 'WithdrawToCard | Vtb',
    value: '100000000005',
  },
  Alfabank: {
    title: 'WithdrawToCard | Alfabank',
    value: '100000000008',
  },
  Rayffayzenbank: {
    title: 'WithdrawToCard | Rayffayzenbank',
    value: '100000000007',
  },
  Otkritie: {
    title: 'WithdrawToCard | Otkritie',
    value: '100000000015',
  },
  Gazprombank: {
    title: 'WithdrawToCard | Gazprombank',
    value: '100000000001',
  },
  Promsvyazbank: {
    title: 'WithdrawToCard | Promsvyazbank',
    value: '100000000010',
  },
  Homecredit: {
    title: 'WithdrawToCard | Homecredit',
    value: '100000000024',
  },
  Rosselxozbank: {
    title: 'WithdrawToCard | Rosselxozbank',
    value: '100000000020',
  },
  Rosbank: {
    title: 'WithdrawToCard | Rosbank',
    value: '100000000012',
  },
  MoskovskiyKreditnyyBank: {
    title: 'WithdrawToCard | MoskovskiyKreditnyyBank',
    value: '100000000025',
  },
  Sovkombank: {
    title: 'WithdrawToCard | Sovkombank',
    value: '100000000013',
  },
  MTSBank: {
    title: 'WithdrawToCard | MTSBank',
    value: '100000000017',
  },
  PochtaBank: {
    title: 'WithdrawToCard | PochtaBank',
    value: '100000000016',
  },
}

export { banks }
